'use client'

import { useCallback } from 'react'
import { ItemBase } from '../base'
import PriceContent from '@homeSearch/modules/filter/content/list/item/price/content'
import { isUndefined, omit } from 'lodash-es'
import { filterToObject, priceToAlias } from '@plugin/searchRoute/modules/house'
import { useMoreFilterContext } from '../context'
import { HOUSE_FILTER_ALIAS } from '@config'

export default function FilterItemPrice({
  data
}) {

  const { baseData, setSelectFilter, selectPrice, setPrice } = useMoreFilterContext()
  const changeHandle = useCallback(({ priceFrom, priceTo }) => {
    if (!isUndefined(priceFrom) || !isUndefined(priceTo)) {
      setPrice([priceFrom, priceTo])
      const alias = filterToObject(priceToAlias(priceFrom, priceTo, baseData))
      setSelectFilter(d => ({ ...d, ...alias }))
    } else {
      setPrice([])
      setSelectFilter(d => {
        if (!d) return {}
        const alias = Object.keys(d).find(key => HOUSE_FILTER_ALIAS.price.includes(key))
        return omit(d, alias)
      })
    }

  }, [setPrice, setSelectFilter, baseData])

  return (
    <ItemBase data={data} collapse={false}>
      <PriceContent data={data.children} onChange={changeHandle} value={selectPrice}></PriceContent>
    </ItemBase>
  )
}